import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Literature.scss';
var LiteratureThumbReactView = function (_a) {
    var width = _a.width, height = _a.height, deviation = _a.deviation;
    return (React.createElement("div", { className: s['root'], style: { width: width, height: height } },
        React.createElement(MinimalDumbo, { width: width, height: height, deviation: deviation })));
};
LiteratureThumbReactView.displayName = 'LiteratureThumbReactView';
export default LiteratureThumbReactView;
//# sourceMappingURL=Literature.js.map